/* eslint-disable no-undef */
// Show more in partial public/booking_appointment/date_availabilities/_slots.html.erb
document.addEventListener('DOMContentLoaded', () => {
  window.changeSlot = (e, value) => {
    e.target.innerHTML = value
  }

  window.showMore = () => {
    document.querySelectorAll('.timeslots .hidden').forEach(element => {
      element.classList.remove('hidden')
    })
    document.querySelector('.show-more').classList.add('hidden')
  }

  window.phoneMask = phone => {
    return phone
      .replace(/\D/g, '')
      .replace(/^(\d)/, '($1')
      .replace(/^(\d)/, '($1')
      .replace(/^(\(\d{3})(\d)/, '$1) $2')
      .replace(/(\d{3})(\d{1,5})/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  window.disableSubmitButtion = () => {
    const formSubmitButton = document.querySelector("button[type='submit']")
    formSubmitButton.toggleAttribute('disabled')
    formSubmitButton.classList.toggle('disabled:opacity-25')
  }

  if (document.querySelector('[data-phone-mask=true]')) {
    document
      .querySelector('[data-phone-mask=true]')
      .addEventListener('input', function(e) {
        e.target.value = window.phoneMask(e.target.value)
      })
  }

  window.changeVirtualMethod = () => {
    let force =
      document.getElementById('patient_contact_method').value === 'FaceTime'

    document.getElementById('zoom-message').classList.toggle('hidden', force)
    document
      .getElementById('facetime-message')
      .classList.toggle('hidden', !force)
  }

  window.scheduleAppointment = async () => {
    // Wait for analytics to be ready
    if (window.analyticsReady) {
      await window.analyticsReady
    }

    if (window.analytics?.track) {
      window.analytics.track('Appointment Booked', {
        category: 'Clearworks',
        label: 'Appointment Booked by Customer',
        date: new Date().toISOString(),
        type:
          document.querySelector('form[data-analytics-type]')?.dataset
            ?.analyticsType || 'Unknown',
        source: 'External Iframe',
      })
    }
  }
})
